import { render, staticRenderFns } from "./CompanyInventoryCategoryPage.vue?vue&type=template&id=85174508&scoped=true&"
import script from "./CompanyInventoryCategoryPage.vue?vue&type=script&lang=js&"
export * from "./CompanyInventoryCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85174508",
  null
  
)

export default component.exports